module.exports = __webpack_public_path__ + "readmeTemplates/OSH_design.a7b31be75a9530402d3d53dafbfdad9a.md";